// src/components/ContactHero.js
import React from "react";
import "./ContactHero.css";
import { useTranslation } from "react-i18next";
// ContactHero.js
export default function ContactHero({ imageUrl="./Images/picture_contact_2.jpg", objectPosition="center 50%" }) {
 const { t } = useTranslation("contactPage");
  return (

    <section className="contact-hero hero" aria-label="Contact hero">
      <img className="hero-img" src={imageUrl} alt="" style={{ objectPosition }} />
      <div className="hero-overlay" />
      <div className="hero-gradient-top" />
      <div className="hero-content">
        <h1 className="hero-title">{t("ti")}</h1>
        {/* si tu veux des meta à droite, ajoute un bloc .hero-meta ici */}
      </div>
    </section>
  );
}
